import React from 'react'
import { styled } from '@mui/material'
import Box from '@mui/material/Box'
import CircularProgress from '@mui/material/CircularProgress'
import BarChart from '../HistoricalData/components/Charts/BarChart/BarChart'
import * as CHART_UTILS from '../HistoricalData/components/Charts/BarChart/BarChart.constant'

const ChartContainer = styled('div')(({ theme }) => ({
  width: '100%',
  height: '600px',
  padding: '16px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  border: '1px solid #ccc',
  borderRadius: '8px',
  boxShadow: '0 4px 6px rgba(0, 0, 0, 0.1)',
  position: 'relative'
}))

const TitleWrapper = styled('div')(({ theme }) => ({
  position: 'absolute',
  top: '16px',
  left: 0,
  width: '100%',
  padding: '0 16px',
  borderBottom: `1px solid ${theme.palette.divider}`,
  boxSizing: 'border-box'
}))

const ChartTitle = styled('h4')(() => ({
  margin: 0,
  fontSize: '1.17rem'
}))

const PressingMachineGraph = ({ pressingMachine = [], isLoading = false }) => {
  const chartTitle = 'Pressing machine load trend'

  const chartLabels = pressingMachine.map((item) => `${item.time}`)
  const bushLoadData = pressingMachine.map((item) =>
    item.bushLoad && item.bushLoad > 0 ? item.bushLoad : null
  )
  const minLoadData = pressingMachine.map((item) => item.minLoad || 0)
  const maxLoadData = pressingMachine.map((item) => item.maxLoad || 0)

  const dataGroup = [
    {
      type: 'line',
      label: 'Bush Load',
      data: bushLoadData,
      borderColor: '#04b890',
      backgroundColor: 'rgba(122, 250, 222, 0.1)',
      borderWidth: 3,
      pointRadius: 1,
      pointHoverRadius: 5,
      pointBackgroundColor: '#04b890',
      fill: false,
      tension: 0.1
    },
    {
      type: 'line',
      label: 'Min Load',
      data: minLoadData,
      borderColor: '#fa465b',
      backgroundColor: 'rgba(250, 155, 166, 0.1)',
      borderWidth: 3,
      pointRadius: 1,
      pointHoverRadius: 5,
      pointBackgroundColor: '#fa465b',
      fill: false,
      tension: 0.1
    },
    {
      type: 'line',
      label: 'Max Load',
      data: maxLoadData,
      borderColor: '#b55d05',
      backgroundColor: 'rgba(245, 174, 103, 0.1)',
      borderWidth: 3,
      pointRadius: 1,
      pointHoverRadius: 5,
      pointBackgroundColor: '#b55d05',
      tension: 0.1,
      fill: false
    }
  ]

  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        gap: '16px',
        padding: '16px'
      }}
    >
      <ChartContainer>
        <TitleWrapper>
          <ChartTitle>{chartTitle}</ChartTitle>
        </TitleWrapper>
        {isLoading ? (
          <CircularProgress />
        ) : (
          <BarChart
            chartTitle={chartTitle}
            chartLabels={chartLabels}
            dataGroup={dataGroup}
            xLabel="Time"
            yLabel="Load (Kg)"
            options={{
              responsive: true,
              maintainAspectRatio: false,
              interaction: {
                mode: 'index',
                intersect: false
              },
              plugins: {
                tooltip: {
                  mode: 'index',
                  intersect: false,
                  callbacks: {
                    label: function (context) {
                      return `${context.dataset.label}: ${context.parsed.y} kg`
                    }
                  }
                },
                legend: {
                  position: 'top',
                  labels: {
                    usePointStyle: true,
                    padding: 20
                  }
                }
              },
              scales: {
                y: {
                  beginAtZero: true,
                  min: 0,
                  max: 1000,
                  title: {
                    display: true,
                    text: 'Load (kg)',
                    color: CHART_UTILS.Y_SCALE.title.color,
                    font: CHART_UTILS.Y_SCALE.title.font
                  },
                  grid: {
                    color: 'rgba(0, 0, 0, 0.1)'
                  }
                },
                x: {
                  title: {
                    display: true,
                    text: 'Time',
                    color: CHART_UTILS.X_SCALE.title.color,
                    font: CHART_UTILS.X_SCALE.title.font
                  },
                  grid: {
                    display: false
                  }
                }
              }
            }}
          />
        )}
      </ChartContainer>
    </Box>
  )
}

export default PressingMachineGraph
